export default __webpack_public_path__ + "static/media/standinbgTableBgDec2.a4238422.png";